import { API_ENDPOINTS } from "../constants/apiEndpoints";
import axiosInstance from "../config/axiosInstance";

/**
 * Lấy danh sách tin tức theo mã ngôn ngữ
 * @param {string} languageCode - Mã ngôn ngữ (vd: 'vi', 'en', 'jp')
 * @returns {Promise<Array>} - Danh sách tin tức
 */
export const getNewsByLanguage = async (languageCode) => {
    try {
        const response = await axiosInstance.get(
            API_ENDPOINTS.NEWS.GET_BY_LANGUAGE(languageCode)
        );
        const data = response.data;

        if (data && data.success && Array.isArray(data.data)) {
            return data.data;
        }

        if (Array.isArray(data)) {
            return data;
        }

        if (data && Array.isArray(data.data)) {
            return data.data;
        }

        return [];
    } catch (error) {
        console.error("Lỗi khi lấy danh sách tin tức:", error);
        throw error;
    }
};
